import { Card, Stack, Text } from '@etg/wings';
import { css } from '@eti/styles';
import { CABIN_UPGRADE } from '../../../products';
import { jsx as _jsx } from "react/jsx-runtime";
const additionalContentTextStyles = css`
  display: flex;
  flex-direction: column;
`;
const additionalContentListStyles = css`
  list-style: disc;
  margin-left: 16px;
`;
const CabinUpgradeContentInfoCard = _ref => {
  let {
    drawerAdditionalContentText
  } = _ref;
  if (!(drawerAdditionalContentText !== null && drawerAdditionalContentText !== void 0 && drawerAdditionalContentText.length)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Card, {
    className: additionalContentTextStyles,
    "data-testid": `${CABIN_UPGRADE.name}-drawer-additional-content-card`,
    children: /*#__PURE__*/_jsx(Stack, {
      as: "ul",
      className: additionalContentListStyles,
      spacing: 0,
      children: drawerAdditionalContentText.map((text, index) => /*#__PURE__*/_jsx(Text, {
        as: "li",
        children: text
      }, index))
    })
  });
};
export default CabinUpgradeContentInfoCard;
//# sourceMappingURL=CabinUpgradeContentInfoCard.js.map